<script setup>
import { useCasinoGamesStore } from '~/stores/casino-games'

const props = defineProps(['param']);
const casinoGamesStore = useCasinoGamesStore()

const toggleProvider = (provider) => {
    casinoGamesStore.toggleProvider(provider.id)
    casinoGamesStore.toggleProviderName(provider.name)
}

onBeforeMount(async() => {
    await casinoGamesStore.getProvider(props.param);
}) 

onBeforeUnmount(() => {
   casinoGamesStore.resetFilters();  
});

const isSelected = computed(() => {
    return (providerId) =>  casinoGamesStore.state.searchByProvider.includes(providerId);
})
</script>

<template>
    <!-- Início dos filtros-->
    <div class="flex gap-2 h-10 w-full">
        <div class="relative h-full w-4/6 overflow-hidden rounded-md bg-brand-input border border-brand-separator">
            <form class="w-full h-full" autocomplete="off" @submit.prevent="">
            <input @input="casinoGamesStore.searchByText" v-model="casinoGamesStore.state.searchString" name="search-games-provider" class="h-full w-full outline-none bg-brand-input px-3 placeholder:text-bzMenuTextDark" type="text" placeholder="Pesquise um jogo...">

            </form>
            <button class="absolute right-2 top-[5px] flex items-center justify-center h-7 w-7 bg-bzRed rounded-lg">
                <svg class="w-4 fill-white" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
            </button>
        </div>

        <div class="relative w-2/6">

            <input type="checkbox" name="dropdown2Cy" id="dropdown2Cy" class="peer delay-1000 hidden">
            <!--  DropDown -->
            <label for="dropdown2Cy">
                <div class="flex items-center justify-center gap-2 font-bold h-full text-xs sm:text-sm overflow-hidden rounded-md bg-brand-input border border-brand-separator select-none cursor-pointer peer-checked:bg-bzRed">
                    <p>Provedores:</p>
                    <p v-if="casinoGamesStore.state.searchByProvider.length === 0">Todos</p>
                    <p v-else>{{casinoGamesStore.state.searchByProvider.length }}</p>
                </div>
            </label>
       
            <!-- Efeito de click fora pra fechar o DropDown -->
            <label for="dropdown2Cy" class="peer-checked:block hidden h-screen w-screen fixed top-0 left-0 z-50"></label>

            <!-- Menu DropDown -->
            <div class="peer-checked:h-96 h-0 absolute top-12 z-50 right-px w-56 sm:w-full bg-brand-input rounded-md shadow-2xl transition-all overflow-hidden overflow-y-auto">
                
                <label v-for="provider in casinoGamesStore.gameProviders" :key="provider.id">
                    <div class="flex items-center gap-3 h-10 px-4 border-b border-brand-separator select-none">
                        <input type="checkbox" :value="provider.id" :checked="isSelected(provider.id)" @click="toggleProvider(provider)">
                        <p>{{ provider.name }}</p>
                    
                        <span class="py-1 px-2 text-xs font-bold bg-brand-separator rounded-md">
                            <p>{{ provider.games_count }}</p>
                        </span>
                    </div>
                </label>

            </div>
        </div>
    </div>
    <!-- Fim dos filtros -->
</template>